// extracted by mini-css-extract-plugin
export default {"occupanciesContainer":"rate_plan_occupancy_occupanciesContainer__yMhj+","occupancyCell":"rate_plan_occupancy_occupancyCell__KS++G"};